// Logical Groups tab — leaf under SiteLayout.

import { createFileRoute } from "@tanstack/react-router";

import { LogicalGroupListPanel } from "../features/logicalGroups/LogicalGroupListPanel";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/logical-groups",
)({
  component: LogicalGroupsRoute,
});

function LogicalGroupsRoute() {
  const { accountSlug, tenantSlug, siteSlug } = Route.useParams();
  return (
    <LogicalGroupListPanel
      accountSlug={accountSlug}
      tenantSlug={tenantSlug}
      siteSlug={siteSlug}
    />
  );
}
